import { render, staticRenderFns } from "./WizardTab.vue?vue&type=template&id=5331bd0f"
import script from "./WizardTab.vue?vue&type=script&lang=js"
export * from "./WizardTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports